import { formatDuration, formatEmotion, formatLanguage, getVoiceName } from "../../utils/voiceUtils";

function VoiceRecordItem({ 
    voice, 
    voiceIndex, 
    isSelectingVoice, 
    isSelected, 
    onSelect, 
    onPlayVoice, 
    onCopy , currentPlayingId, isPlaying
}) {
    try {        
        return (
            <div 
                className={`bg-white p-2 rounded border ${
                    isSelectingVoice && isSelected 
                        ? 'border-green-500 ring-2 ring-green-300' 
                        : 'border-blue-100'
                } flex items-center justify-between cursor-pointer`}
                onClick={() => isSelectingVoice && onSelect(voice.id)}
                data-name={`voice-record-${voiceIndex}`}
            >
                <div className="flex items-center space-x-2">
                    <button 
                        onClick={(e) => {
                            e.stopPropagation();
                            onPlayVoice(voice);
                        }}
                        className="w-8 h-8 rounded-full bg-blue-500 text-white flex items-center justify-center hover:bg-blue-600"
                        title="播放語音"
                        data-name={`play-voice-${voiceIndex}`}
                    >
                        <i className={`fas ${currentPlayingId === voice.id && isPlaying ? 'fa-pause' : 'fa-play'}`}></i>
                    </button>
                    <div>
                        <div className="font-medium text-gray-800">
                            {getVoiceName(voice.voice_id)}
                        </div>
                        <div className="text-xs text-gray-500 flex flex-wrap gap-2">
                            <span>{formatLanguage(voice.language)}</span>
                            <span>•</span>
                            <span>語速: {voice.speed}x</span>
                            <span>•</span>
                            <span>情緒: {formatEmotion(voice.emotion)}</span>
                            <span>•</span>
                            { voice.extra_info?.audio_length && <>
                                <span>時長: {formatDuration(voice.extra_info?.audio_length)}</span>
                                <span>•</span>
                            </> }
                            <span>{new Date(voice.create_time).toLocaleString('zh-TW')}</span>
                        </div>
                    </div>
                </div>
                <div className="flex space-x-2">
                    {isSelectingVoice ? (
                        <div className={`w-6 h-6 rounded-full border ${
                            isSelected
                                ? 'bg-green-500 border-green-600' 
                                : 'bg-white border-gray-300'
                        } flex items-center justify-center`}>
                            {isSelected && (
                                <i className="fas fa-check text-white text-xs"></i>
                            )}
                        </div>
                    ) : (
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                onCopy(voice.url);
                            }}
                            className="text-blue-600 hover:text-blue-800 p-1"
                            title="複製語音連結"
                            data-name={`copy-voice-url-${voiceIndex}`}
                        >
                            <i className="fas fa-link"></i>
                        </button>
                    )}
                </div>
            </div>
        );
    } catch (error) {
        console.error('VoiceRecordItem component error:', error);
        reportError(error);
        return null;
    }
}

export default VoiceRecordItem;